import {applyInteractionId} from '@servicenow/ui-metrics';
import {CONFIG, DISPATCH, INTERNAL_HOST_DISPATCH, PRESENTATIONAL} from '../symbols';
import {emitNowUiEvent, getHostVariables, getSpanOptions} from '../utils';
import {
	ACTION_DISPATCHED,
	SPAN_ATTR_DISPATCH_ACTION_TYPE,
	SPAN_FOR_DISPATCH,
	SPAN_KIND_CLIENT,
	SPAN_LIFECYCLE_EVENTS,
	SPAN_ATTR_CONDITIONAL
} from '../constants';
import * as uiAnalyticsConsumer from '@servicenow/ui-analytics-consumer';
const {trace, isValidTraceId} = uiAnalyticsConsumer;

export function createConditionalDispatch(host) {
	return function conditionalDispatch(type, payload, meta, error) {
		applyInteractionId(meta);
		const hostVariables = getHostVariables(host);
		const shouldDispatch =
			!hostVariables[PRESENTATIONAL] && hostVariables[CONFIG].shouldDispatch[type];
		if (shouldDispatch) {
			return dispatchWithLifecycleSpan({type, payload, meta, error, host});
		}

		emitNowUiEvent(ACTION_DISPATCHED, {host, action: {type, payload, meta, error}});
	};
}

function dispatchWithLifecycleSpan(options) {
	const {type, payload, meta, error, host} = options;
	const hostVariables = getHostVariables(host);
	const spanOptions = getSpanOptions(host);

	let lifecycleSpan;
	const parentSpan = meta.span;
	if (parentSpan && isValidTraceId(parentSpan.traceId)) {
		const traceName = SPAN_LIFECYCLE_EVENTS[type];
		if (traceName) {
			lifecycleSpan = createLifecycleSpan(spanOptions, parentSpan, traceName);
			meta.span = isValidTraceId(lifecycleSpan.traceId) && lifecycleSpan;
		}
	}
	meta[INTERNAL_HOST_DISPATCH] = meta.internal === true;
	const result = hostVariables[DISPATCH](type, payload, meta, error);
	if (lifecycleSpan) lifecycleSpan.end();

	return result;
}

function createLifecycleSpan(spanOptions, parentSpan, traceName) {
	const lifecycleSpan = trace(SPAN_FOR_DISPATCH, {
		...spanOptions,
		traceId: parentSpan.traceId,
		kind: SPAN_KIND_CLIENT,
		parentSpan
	});
	lifecycleSpan.setAttribute(SPAN_ATTR_DISPATCH_ACTION_TYPE, traceName);
	lifecycleSpan.setAttribute(SPAN_ATTR_CONDITIONAL, true);

	return lifecycleSpan;
}
